<template>
  <section class="container ">
    <div>
      <p>
        เนื่องจากการใช้งานระบบบริจาคอิเล็กทรอนิกส์จำเป็นต้องส่งข้อมูลระหว่างมหาวิทยาลัยกับธนาคารจึงต้องใช้งานผ่านเเว็บเบราว์เซอร์ของโทรศัพท์มือถือหรือคอมพิวเตอร์
        เท่านั้น ไม่สามารถใช้งานผ่าน messenger หรือ Line ได้
      </p>
    </div>
    <div id="ios" class="py-3">
      <h5>วิธีเปิดเบราว์เซอร์ของโทรศัพท์มือถือระบบปฏิบัติการiOS (iPhone iPad)</h5>
      <p>
        <img
          src="@/assets/images/inAppBrowser/ios1.png"
          alt="ios1"
          class="rounded mx-auto d-block"
        />
      </p>
      <p>
        <img
          src="@/assets/images/inAppBrowser/ios2.png"
          alt="ios2"
          class="rounded mx-auto d-block"
        />
      </p>
    </div>
    <div id="android" class="py-3">
      <h5>วิธีเปิดเบราว์เซอร์ของโทรศัพท์มือถือระบบปฏิบัติการAndroid</h5>
      <img
        src="@/assets/images/inAppBrowser/android1.png"
        alt="ios2"
        class="rounded mx-auto d-block"
      />
      <img
        src="@/assets/images/inAppBrowser/android2.png"
        alt="ios2"
        class="rounded mx-auto d-block"
      />
    </div>
  </section>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';

// It is recommended to use a state management solution (like Pinia)
// to control the visibility of the header from different components.
const hideHeader = () => {
  const headers = document.querySelectorAll('.site-header');
  headers.forEach((header) => {
    header.style.display = 'none';
  });
};

const showHeader = () => {
  const headers = document.querySelectorAll('.site-header');
  headers.forEach((header) => {
    header.style.display = '';
  });
};

onMounted(() => {
  hideHeader();
});

onUnmounted(() => {
  showHeader();
});
</script>

<style scoped>
</style>
